import type { Card } from '../types';
import { Group, Rect, Text, Circle } from 'react-konva';
import { GENRE_NAMES, CardGenre } from '../types';

interface PlayedCardsProps {
  cards: Card[];
  genre?: number | null;
  x: number;
  y: number;
}

const CARD_WIDTH = 50;
const CARD_HEIGHT = 70;

export function PlayedCards({ cards, genre, x, y }: PlayedCardsProps) {
  if (cards.length === 0) {
    return null;
  }

  const sortedCards = [...cards].sort((a, b) => b.valueNum - a.valueNum);
  const totalWidth = sortedCards.length * (CARD_WIDTH - 20);
  const startX = x - totalWidth / 2;

  return (
    <Group x={x} y={y}>
      {sortedCards.map((card, index) => (
        <Group key={card.id} x={startX + index * (CARD_WIDTH - 20)} y={0}>
          <SmallCard card={card} />
        </Group>
      ))}

      {genre && (
        <Text
          x={-40}
          y={80}
          text={GENRE_NAMES[genre as CardGenre] || ''}
          fontSize={18}
          fill="#ffd700"
          fontStyle="bold"
        />
      )}
    </Group>
  );
}

function SmallCard({ card }: { card: Card }) {
  const isRedSuit = card.suit === '♥' || card.suit === '♦';
  const suitColor = isRedSuit ? '#e74c3c' : '#2c3e50';
  const isRed = card.suit === '♥' && card.isRedHeart;
  const isJoker = card.suit === '';

  return (
    <>
      <Rect
        width={CARD_WIDTH}
        height={CARD_HEIGHT}
        fill="#fff"
        stroke="#888"
        strokeWidth={1}
        cornerRadius={4}
      />
      {isJoker ? (
        <>
          <Text
            x={CARD_WIDTH / 2 - 8}
            y={20}
            text="Joker"
            fontSize={10}
            fill="#2c3e50"
          />
          <Circle
            x={CARD_WIDTH / 2}
            y={CARD_HEIGHT / 2 + 5}
            radius={15}
            fill={card.value === 'joker_big' ? '#9b59b6' : '#3498db'}
          />
          <Text
            x={CARD_WIDTH / 2 - 8}
            y={CARD_HEIGHT / 2 - 5}
            text={card.value === 'joker_big' ? '大' : '小'}
            fontSize={14}
            fill="#fff"
            fontStyle="bold"
          />
        </>
      ) : (
        <>
          <Text
            x={3}
            y={3}
            text={card.value}
            fontSize={10}
            fontStyle="bold"
            fill={isRed ? '#e74c3c' : suitColor}
          />
          <Text
            x={3}
            y={15}
            text={card.suit}
            fontSize={12}
            fill={isRed ? '#e74c3c' : suitColor}
          />
          <Text
            x={CARD_WIDTH / 2}
            y={CARD_HEIGHT / 2}
            text={card.suit}
            fontSize={18}
            fill={isRed ? '#e74c3c' : suitColor}
            offsetX={9}
            offsetY={9}
          />
        </>
      )}
    </>
  );
}